import { TTableStructure, ETableStructureType, ETableStructureAlign } from 'ui/EasTable/types';
import { TSpecialRegistrationItem } from 'redux/reducers/emManagement/types';
import { Cancel, Delete, Edit, EventBusy, EventRepeat, Stop } from '@mui/icons-material';
import { ESpecialRegistrationSchemeType } from '../../../../../redux/reducers/emManagement/constants';
import { ESpecialRegistrationAction } from './constants';
import { EIconButtons } from '../../../../../ui/EasTable/EasTableRow/EasTableValue/constants';

export const tableStructure: TTableStructure<
	keyof TSpecialRegistrationItem,
	TSpecialRegistrationItem
>[] = [
	{
		name: 'ID',
		selector: 'id',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Scheme type',
		selector: 'specialSchemeType',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STATUS,
		align: ETableStructureAlign.LEFT,
		editable: true,
		filter: [
			[ESpecialRegistrationSchemeType.IOSS, ESpecialRegistrationSchemeType.IOSS],
			[ESpecialRegistrationSchemeType.UNION, ESpecialRegistrationSchemeType.UNION],
			[ESpecialRegistrationSchemeType.NON_UNION, ESpecialRegistrationSchemeType.NON_UNION],
			[ESpecialRegistrationSchemeType.NON_EU, ESpecialRegistrationSchemeType.NON_EU],
		],
		// colors: [
		// 	[ESpecialRegistrationSchemeType.IOSS, '#90CAF970'],
		// 	[ESpecialRegistrationSchemeType.UNION, '#CE93D870'],
		// 	[ESpecialRegistrationSchemeType.NON_UNION, '#FFB74D70'],
		// 	[ESpecialRegistrationSchemeType.NON_EU, '#9595D570'],
		// ],
	},

	{
		name: 'EM ID',
		selector: 'emId',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Full name',
		selector: 'fullName',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Scheme number',
		selector: 'schemeNumber',
		editable: true,
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'EM non EU VAT ID',
		selector: 'emNonEuVatId',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Termination ID',
		selector: 'terminationId',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Country',
		selector: 'schemeCountry',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.COUNTRY_CODE_EU,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Country',
		selector: 'countryId',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.COUNTRY_NUMBER,
		align: ETableStructureAlign.LEFT,
		editable: true,
	},

	{
		name: 'Registration date',
		selector: 'registrationRequestDate',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.LEFT,
		editable: true,
	},
	{
		name: 'Commencement date',
		selector: 'commencementDate',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.LEFT,
		editable: true,
	},
	{
		name: 'Removal enabled',
		selector: 'removalEnabled',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.BOOLEAN,
		align: ETableStructureAlign.CENTER,
	},
	{
		name: 'Termination date',
		selector: 'removalDate',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Termination code 3',
		selector: 'terminationCode3',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.BOOLEAN,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'EAS number used',
		selector: 'easNumberUsed',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.BOOLEAN,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Actions',
		selector: 'actions',
		noName: true,
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.BUTTONS,
		align: ETableStructureAlign.LEFT,
		buttons: [
			{
				name: 'Edit',
				icon: EIconButtons.EDIT,
			},
			{
				name: 'Terminate',
				icon: EIconButtons.CANCEL,
			},
		],
		buttonFilter: (item: TSpecialRegistrationItem) => {
			if (item.removalEnabled) {
				return [
					{ name: ESpecialRegistrationAction.EDIT, icon: EIconButtons.EDIT },
					{ name: ESpecialRegistrationAction.CANCEL_TERMINATION, icon: EIconButtons.EVENT_REPEAT },
				];
			}
			return [
				{ name: ESpecialRegistrationAction.EDIT, icon: EIconButtons.EDIT },
				{ name: ESpecialRegistrationAction.TERMINATE, icon: EIconButtons.EVENT_BUSY },
			];
		},
	},
];
